import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import EmptyState from "../../components/Ui/EmptyState";

const coursesInit = [];

export default function CourseList() {
  const navigate = useNavigate();
  const [courses, setCourses] = useState(coursesInit);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get("/api/app/courses");
        setCourses(data?.data || []);
      } catch (e) {}
      setLoading(false);
    };
    fetchData();
  }, []);
  return (
    <div className="h-screen flex flex-col" style={{ height: 'calc(100vh - 120px)' }}>
      <div className="p-4 md:p-8 pb-0 flex-shrink-0">
        <div className="mb-6 flex items-start justify-between gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl text-left font-semibold">Courses</h1>
            <p className="text-gray-500">Pick a course to start learning.</p>
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-4 md:px-8 pb-4 md:pb-8 min-h-0">
        {(!loading && (!courses || courses.length === 0)) && (
          <EmptyState
            icon="arrow"
            title="We will update soon"
            subtitle="Courses are coming shortly. Please check back later."
          />
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {courses.map((c) => (
          <button
            key={c._id}
            className="text-left group border rounded-2xl overflow-hidden bg-white hover:shadow transition flex flex-col h-full"
            onClick={() => navigate(`/home/courses/${c._id}/player`)}
          >
            <div className="aspect-[16/9] w-full overflow-hidden bg-gray-100 relative flex-shrink-0">
              <img
                src={c.thumbnail}
                alt={c.title}
                className="w-full h-full object-cover group-hover:scale-105 transition"
              />
              {c.isCompleted && (
                <span className="absolute top-2 right-2 inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 border border-emerald-200">
                  ✓ Completed
                </span>
              )}
            </div>
            <div className="p-4 flex flex-col flex-grow">
              <div className="font-semibold text-lg line-clamp-2 mb-2 min-h-[3.5rem] flex items-start">
                {c.title}
              </div>
              {c.shortDescription && (
                <div className="text-sm text-gray-500 line-clamp-3 mb-3 flex-grow">
                  {c.shortDescription}
                </div>
              )}
              {typeof c.progressPercent === 'number' && (
                <div className="mt-auto">
                  <div className="h-1.5 w-full bg-gray-100 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gray-900 transition-all"
                      style={{ width: `${c.progressPercent}%` }}
                    />
                  </div>
                  <div className="mt-1 text-[11px] text-gray-500">{c.progressPercent}% completed</div>
                </div>
              )}
            </div>
          </button>
        ))}
        </div>
        {loading && (
          <div className="text-center text-gray-500 mt-6">Loading...</div>
        )}
      </div>
    </div>
  );
}


